import _ from "lodash";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import { workflowRequests } from "@/api/(requests)/workflow";

import ConfirmIntakeConsultation from "./ConfirmIntakeConsultation";
import ScheduleIntakeConsultation from "./ScheduleIntakeConsultation";
import ThankYouIntakeSchedule from "./ThankYouIntakeSchedule";
import WorkflowHeader from "./WorkflowHeader";

const getSchedulingData = async (sharedWorkflowData) => {
  const data = {
    timezone: moment.tz.guess(),
    workflow_instance_sort_key: sharedWorkflowData.workflow_instance.sort_key,
  };

  const headers = {
    "X-On-Behalf-Of": sharedWorkflowData.workflow_instance.entity_id,
    "X-On-Behalf-Of-Entity-Type": "patient",
  };

  return workflowRequests.get_schedule_info({ data, headers });
};

const LoadingIntakeSchedule = (props) => {
  return <WorkflowHeader header="Loading scheduling data..." showImage={false} />;
};

const DynamicIntakeSchedulingArea = ({
  addToInAppHistory,
  alreadyScheduled,
  appToDisplay,
  consultationToConfirm,
  goBackInAppHistory,
  props,
  schedulingData,
  setAlreadyScheduled,
  setAppToDisplay,
  setConsultationToConfirm,
  setSchedulingData,
  setSharedWorkflowData,
  setWithinAppHistory,
  withinAppHistory,
  workflowInstance,
}) => {
  const lookup = {
    confirmConsultation: () => (
      <ConfirmIntakeConsultation
        addToInAppHistory={addToInAppHistory}
        alreadyScheduled={alreadyScheduled}
        appToDisplay={appToDisplay}
        consultationToConfirm={consultationToConfirm}
        goBackInAppHistory={goBackInAppHistory}
        schedulingData={schedulingData}
        setAlreadyScheduled={setAlreadyScheduled}
        setAppToDisplay={setAppToDisplay}
        setConsultationToConfirm={setConsultationToConfirm}
        setWithinAppHistory={setWithinAppHistory}
        withinAppHistory={withinAppHistory}
        workflowInstance={workflowInstance}
      />
    ),
    loading: () => <LoadingIntakeSchedule setAppToDisplay={setAppToDisplay} />,
    scheduleConsultation: () => (
      <ScheduleIntakeConsultation
        addToInAppHistory={addToInAppHistory}
        alreadyScheduled={alreadyScheduled}
        appToDisplay={appToDisplay}
        consultationToConfirm={consultationToConfirm}
        goBackInAppHistory={goBackInAppHistory}
        schedulingData={schedulingData}
        setAlreadyScheduled={setAlreadyScheduled}
        setAppToDisplay={setAppToDisplay}
        setConsultationToConfirm={setConsultationToConfirm}
        setSchedulingData={setSchedulingData}
        setWithinAppHistory={setWithinAppHistory}
        withinAppHistory={withinAppHistory}
        workflowInstance={workflowInstance}
      />
    ),
    thankYou: () => <ThankYouIntakeSchedule props={props} />,
  };

  return lookup[appToDisplay]();
};

const addToInAppHistory = (
  appToDisplay,
  setAppToDisplay,
  alreadyScheduled,
  setAlreadyScheduled,
  consultationToConfirm,
  setConsultationToConfirm,
  withinAppHistory,
  setWithinAppHistory,
) => {
  const funcToRestoreThisState = () => {
    setAppToDisplay(appToDisplay);
    setAlreadyScheduled(alreadyScheduled);
    setConsultationToConfirm(consultationToConfirm);
  };

  withinAppHistory.push(funcToRestoreThisState);
  setWithinAppHistory(withinAppHistory);
};

const goBackInAppHistory = (withinAppHistory, setWithinAppHistory) => {
  let f = withinAppHistory.pop();

  f();
  setWithinAppHistory(withinAppHistory);
};

const IntakeScheduling = (props) => {
  const { setSharedWorkflowData, sharedWorkflowData } = props;
  let workflowInstance = sharedWorkflowData.workflow_instance;

  // appToDisplay can we loading | thankYou | confirmConsultation | scheduleConsultation
  const [appToDisplay, setAppToDisplay] = useState("loading");
  const [schedulingData, setSchedulingData] = useState({});
  const [consultationToConfirm, setConsultationToConfirm] = useState(null);
  const [alreadyScheduled, setAlreadyScheduled] = useState(false);

  const priorAppFunc = () => {
    props.history.goBack();
    setSharedWorkflowData({});
  };
  const [withinAppHistory, setWithinAppHistory] = useState([priorAppFunc]);

  useEffect(() => {
    getSchedulingData(sharedWorkflowData)
      .then((response) => {
        const data = response;

        //data?.intake_appointment_data?.appointment_scheduled
        setSchedulingData(data);
        if (_.get(data, "intake_appointment_data.appointment_scheduled", false)) {
          setConsultationToConfirm(_.get(data, "intake_appointment_data.upcoming_appointments[0]"));
          setAlreadyScheduled(true);
          setAppToDisplay("confirmConsultation");
        } else {
          setAppToDisplay("scheduleConsultation");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <DynamicIntakeSchedulingArea
        addToInAppHistory={addToInAppHistory}
        alreadyScheduled={alreadyScheduled}
        appToDisplay={appToDisplay}
        consultationToConfirm={consultationToConfirm}
        goBackInAppHistory={goBackInAppHistory}
        props={props}
        schedulingData={schedulingData}
        setAlreadyScheduled={setAlreadyScheduled}
        setAppToDisplay={setAppToDisplay}
        setConsultationToConfirm={setConsultationToConfirm}
        setSchedulingData={setSchedulingData}
        setSharedWorkflowData={setSharedWorkflowData}
        setWithinAppHistory={setWithinAppHistory}
        withinAppHistory={withinAppHistory}
        workflowInstance={workflowInstance}
      />
    </>
  );
};

export default withRouter(IntakeScheduling);
